/** @jsxRuntime classic */
/** @jsx jsx */
import ExhibitorProductListPage from '@bottlebooks/gatsby-theme-event/src/components/ExhibitorPage/ExhibitorProductListPage';
import Layout from '@bottlebooks/gatsby-theme-event/src/components/Layout/Layout';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';

export default function ExhibitorSidebar(props) {
  const { exhibitor } = afterQuery(props?.data);
  return (
    <Layout>
      <ExhibitorProductListPage exhibitor={exhibitor} />
    </Layout>
  );
}

export const pageQuery = graphql`
  query ExhibitorProducts($partnerId: ID!) {
    exhibitor(exhibitorId: { eq: $partnerId }) {
      ...ExhibitorProductListPage
    }
  }
`;

function afterQuery(data) {
  const exhibitor = data?.exhibitor;
  return {
    exhibitor,
  };
}
